import { Popconfirm, Table } from "antd";
import { get } from "lodash";
import PropTypes from "prop-types";
import { BiChevronLeft, BiTrash } from "react-icons/bi";
import { MdAdd, MdCheck } from "react-icons/md";
import Button from "shared/components/Button";
import Card from "shared/components/Card";
import Header from "shared/components/Header";
import Input from "shared/components/Input";

const DUPLICATE_ROW_CLASS = "lead-typology__row--duplicate";

const View = ({
  COPY,
  rows,
  focusKey,
  emptied,
  duplicates,
  duplicateWarning,
  isDirty,
  canDiscard,
  saving,
  onAdd,
  onEdit,
  onRemove,
  onDiscard,
  onSave,
}) => {
  const columns = [
    {
      title: COPY.LABEL,
      dataIndex: "label",
      render: (label, row) => (
        <Input
          autoFocus={row.key === focusKey}
          value={label}
          placeholder={COPY.LABEL_PLACEHOLDER}
          onChange={(event) =>
            onEdit(row.key, get(event, "target.value", event))
          }
        />
      ),
    },
    {
      title: COPY.ACTIONS,
      dataIndex: "key",
      width: 90,
      render: (key, row) =>
        row.id ? (
          <Popconfirm
            title={COPY.DELETE_CONFIRM}
            okText={COPY.DELETE_OK}
            cancelText={COPY.DELETE_CANCEL}
            onConfirm={() => onRemove(key)}
          >
            <Button type="danger--outlined" size="small">
              <BiTrash size={18} />
            </Button>
          </Popconfirm>
        ) : (
          <Button
            type="danger--outlined"
            size="small"
            onClick={() => onRemove(key)}
          >
            <BiTrash size={18} />
          </Button>
        ),
    },
  ];

  return [
    <Header
      key="header"
      title={COPY.TITLE}
      subtitle={COPY.SUBTITLE}
      actions={[
        {
          text: COPY.DISCARD,
          onClick: onDiscard,
          type: "primary--outlined",
          disabled: !canDiscard || saving,
          icon: <BiChevronLeft size={20} />,
        },
        {
          text: COPY.ADD,
          onClick: onAdd,
          type: "primary--outlined",
          icon: <MdAdd size={20} />,
        },
        {
          text: COPY.SAVE,
          onClick: onSave,
          type: "primary",
          disabled: !isDirty || saving || duplicates > 0,
          loading: saving,
          icon: <MdCheck size={20} />,
        },
      ]}
    />,
    <Card key="card" type="simple">
      <p className="lead-typology__intro">{COPY.INTRO}</p>

      {emptied > 0 && (
        <p className="lead-typology__warning">{COPY.EMPTY_LABEL}</p>
      )}

      {duplicates > 0 && (
        <p className="lead-typology__warning">{duplicateWarning}</p>
      )}

      {isDirty && <p className="lead-typology__warning">{COPY.UNSAVED}</p>}

      <Table
        rowKey="key"
        columns={columns}
        dataSource={rows}
        pagination={false}
        rowClassName={(row) => (row.duplicate ? DUPLICATE_ROW_CLASS : "")}
        locale={{ emptyText: COPY.EMPTY }}
      />
    </Card>,
  ];
};

View.propTypes = {
  COPY: PropTypes.object.isRequired,
  rows: PropTypes.array.isRequired,
  focusKey: PropTypes.string,
  emptied: PropTypes.number.isRequired,
  duplicates: PropTypes.number.isRequired,
  duplicateWarning: PropTypes.string,
  isDirty: PropTypes.bool.isRequired,
  canDiscard: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default View;
